<mat-chip class="recipient-chip-color" [removable]="removable" (removed)="handleRemoveRecipient()" [matTooltip]="recipient.emailAddress" matTooltipPosition="above">
    {{ recipient.name }}
    <mat-icon class="cancel-icon" matChipRemove (click)="handleRemoveRecipient()" data-cy="email-remove-recipient">close</mat-icon>
</mat-chip>
